import { v4 as uuidv4 } from "uuid";

const newId = uuidv4();

export const defaultValues = {
  documents: [],
  translations: [{ languageId: 1 }, { languageId: 2 }, { languageId: 3 }],
  partners: [
    {
      serialNumber: 1,
      id: newId,
      translations: [
        {
          name: "",
          languageId: 1,
        },
        {
          name: "",
          languageId: 2,
        },
        {
          name: "",
          languageId: 3,
        },
      ],
      partnerCompanies: [],
    },
  ],
  publicOffer: [{ languageId: 1 }, { languageId: 2 }, { languageId: 3 }],
  distances: [
    {
      name: "",
      true: [{ gender: true, ageFrom: "", ageTo: "" }],
      false: [{ gender: false, ageFrom: "", ageTo: "" }],
      startNumberRanges: [{ id: "", startNumbersFrom: 1, startNumbersTo: "" }],
      distancePrices: [],
    },
  ],
};
